import { Link } from 'react-router-dom';
import { articleList } from '@/mocks/articles';

const latestArticles = articleList.slice(0, 3);

export default function LatestArticles() {
  return (
    <section className="py-16 md:py-20 bg-background-50" aria-labelledby="articles-heading">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-12 md:mb-14">
          <div>
            <p className="text-xs font-label tracking-[0.15em] uppercase text-foreground-500 mb-3">文章中心</p>
            <h2 id="articles-heading" className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
              品质生活，久久久与您分享
            </h2>
          </div>
          <Link
            to="/articles"
            className="whitespace-nowrap text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 cursor-pointer flex items-center gap-1"
          >
            查看全部文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 font-medium">{article.category}</span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{article.excerpt}</p>
                <div className="mt-4 flex items-center gap-2 text-xs text-foreground-400">
                  <i className="ri-time-line"></i>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}